import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Typography } from "@progress/kendo-react-common";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import FormTextField from "../../components/formFields/FormTextField";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import ShadowCard from "../../components/common/ShadowCard";
import { Button } from "@progress/kendo-react-buttons";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { LoadingPanel } from "../../components/layout/Loading";
import FormImageUpload from "../../components/formFields/FormImageUpload";
// import AppDialog from "../../components/dialog/Dialog";
// import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import { clearItineraryDetails } from "./itinerarySlice";

import FormSelectionField from "../../components/formFields/FormSelectionField";
import { STATUSARRAY } from "../../_contstants/common";
import FormRichTextField from "../../components/formFields/FormRichTextField";
import {
  createItinerary,
  getItineraryByID,
  updateItinerary,
} from "./services/itinerary.services";
import { getAllActiveCities } from "../city/services/city.services";

const CreateItinerary: React.FC = () => {
  const gridRef = useRef<any>(null);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const ItineraryID = location.state?.ItineraryID;
  const [formKey, setFormKey] = useState(1);
  const loading = useAppSelector((state) => state.itinerary.loading);
  const formLoading = useAppSelector((state) => state.itinerary.formLoading);
  const ItineraryDetail = useAppSelector(
    (state) => state.itinerary.ItineraryDetail
  );

  const CityList = useAppSelector((state) => state.city.CityList);

  useEffect(() => {
    if (ItineraryID) {
      dispatch(getItineraryByID(ItineraryID));
    }
  }, [ItineraryID]);

  useEffect(() => {
    dispatch(getAllActiveCities());
    return () => {
      dispatch(clearItineraryDetails());
    };
  }, []);

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [ItineraryDetail]);

  const handleSubmit = async (values: any) => {
    const isactive = values.IsActive === 1;
    if (ItineraryID) {
      try {
        const ImageData = new FormData();
        const file =
          values?.ItineraryImage && typeof values?.ItineraryImage !== "string"
            ? values.ItineraryImage[0].getRawFile()
            : "";
        ImageData.append("ItineraryImage", file);
        ImageData.append("ID", values?.ID ? values?.ID : "");
        ImageData.append("CityID", values?.CityID ? values?.CityID : "");
        ImageData.append("IsActive", `${isactive}`);
        ImageData.append(
          "ItineraryTitle",
          values?.ItineraryTitle ? values?.ItineraryTitle : ""
        );
        ImageData.append(
          "Description",
          values?.Description ? values?.Description : ""
        );

        // const updatePayload: any = {
        //   ID: ItineraryID,
        //   CityID: values?.CityID ? values?.CityID : null,
        //   ItineraryTitle: values?.ItineraryTitle ? values?.ItineraryTitle : "",
        //   Description: values?.Description ? values?.Description : "",
        // };

        // if (ImageData.get("ItineraryImage")) {
        //   updatePayload.ItineraryImage = file;
        // }

        const response = await dispatch(updateItinerary(ImageData));

        if (response?.meta?.requestStatus === "fulfilled") {
          navigate(-1);
          // const ImageData = new FormData();
          // const ItineraryImage =
          //   values?.ItineraryImage && typeof values?.ItineraryImage !== "string"
          //     ? values.ItineraryImage[0].getRawFile()
          //     : "";
          // ImageData.append("ItineraryImage", ItineraryImage);
          // ImageData.append("ItineraryID", ItineraryID);
          // if (typeof values?.ItineraryImage !== "string") {
          //   dispatch(updateItinerary(ImageData));
          // }
        }
      } catch (error) {
        console.error("Error in handleSubmit:", error);
        throw error;
      }
    } else {
      try {
        const ImageData = new FormData();
        const file =
          values?.ItineraryImage && typeof values?.ItineraryImage !== "string"
            ? values.ItineraryImage[0].getRawFile()
            : "";
        ImageData.append("ItineraryImage", file);
        ImageData.append("CityID", values?.CityID ? values?.CityID : "");
        ImageData.append(
          "ItineraryTitle",
          values?.ItineraryTitle ? values?.ItineraryTitle : ""
        );
        ImageData.append(
          "Description",
          values?.Description ? values?.Description : ""
        );
        ImageData.append("IsActive", `${isactive}`);

        const response = await dispatch(createItinerary(ImageData));
        if (response?.meta?.requestStatus === "fulfilled") {
          navigate(-1);
        }
      } catch (error) {
        console.error("Error in handleSubmit:", error);
        throw error;
      }
    }
  };

  return (
    <>
      {(loading || formLoading) && <LoadingPanel gridRef={gridRef} />}
      <Form
        key={formKey}
        onSubmit={handleSubmit}
        initialValues={ItineraryDetail}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement>
            <ShadowCard style={{ padding: 12 }}>
              <GridLayout
                style={{ marginRight: 10 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[{ width: "35%" }, { width: "65%" }]}
              >
                <GridLayoutItem colSpan={2}>
                  <Typography.h4>
                    {ItineraryID ? "Update Itinerary" : "Add Itinerary"}
                  </Typography.h4>
                </GridLayoutItem>

                <GridLayoutItem>
                  <Field
                    name="ItineraryTitle"
                    label="Itinerary Title"
                    placeholder="ItineraryTitle"
                    component={FormTextField}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>
                <GridLayoutItem rowSpan={4}>
                  <Field
                    name="Description"
                    label="Description"
                    placeholder="Description"
                    component={FormRichTextField}
                    wrapperStyle={{
                      width: "100%",
                    }}
                    style={{
                      height: 215,
                    }}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    id={"CityID"}
                    name={"CityID"}
                    label={"City Name"}
                    placeholder="i.e Ahemdabad"
                    component={FormSelectionField}
                    options={CityList?.map((city: any) => {
                      return {
                        value: city?.id,
                        label: city?.city_name,
                      };
                    })}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="IsActive"
                    label="Status"
                    astrike={true}
                    placeholder="i.e. Active"
                    component={FormSelectionField}
                    validator={requiredValidator}
                    options={STATUSARRAY?.map((status: any) => {
                      return {
                        value: status?.value,
                        label: status?.label,
                      };
                    })}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name="ItineraryImage"
                    alternateName="Itinerary Image"
                    type="file"
                    accept="image/*"
                    label="Itinerary Image"
                    component={FormImageUpload}
                    // wrapperStyle={{
                    //   flexDirection: "column",
                    //   alignItems: "start",
                    // }}
                  />
                </GridLayoutItem>
                <GridLayoutItem></GridLayoutItem>

                <GridLayoutItem
                  colSpan={2}
                  style={{
                    marginTop: 20,
                    textAlign: "end",
                  }}
                >
                  <div>
                    <ButtonWithLoading
                      label={ItineraryID ? "Update" : "Save"}
                      type="submit"
                      disabled={!formRenderProps.allowSubmit || loading}
                      loading={loading}
                    />
                    <Button
                      type="button"
                      fillMode={"outline"}
                      themeColor={"primary"}
                      style={{ marginLeft: 10 }}
                      onClick={() => navigate("/itinerary")}
                    >
                      Cancel
                    </Button>
                  </div>
                </GridLayoutItem>
              </GridLayout>
            </ShadowCard>
          </FormElement>
        )}
      />
    </>
  );
};

export default CreateItinerary;
